import React, { Fragment } from 'react';
import { func, string } from 'prop-types';
import { Menu, Icon } from 'semantic-ui-react';


const NobleMenu = ({
    pathname,
    handleMenuItemClick,
    userID,
}) => (
    <Fragment>
        <Menu.Item
            name="My Account"
            icon="user"
            to={`/users/${userID}`}
            onClick={handleMenuItemClick}
            active={pathname === `/users/${userID}`}
        />
        <Menu.Item
            name="Users"
            icon="users"
            to="/users"
            onClick={handleMenuItemClick}
            active={pathname === '/users'}
        />
        <Menu.Item>
            Portals
            <Icon name="university" />
            <Menu.Menu>
                <Menu.Item
                    content="Search"
                    to="/col/portals"
                    onClick={handleMenuItemClick}
                    active={pathname === '/col/portals'}
                />
                <Menu.Item
                    content="Create"
                    to="/col/portals/create"
                    onClick={handleMenuItemClick}
                    active={pathname === '/col/portals/create'}
                />
            </Menu.Menu>
        </Menu.Item>
        <Menu.Item
            name="Reports"
            icon="chart area"
            to="/reports"
            onClick={handleMenuItemClick}
            active={pathname === '/reports'}
        />
        <Menu.Item
            name="Feature Flags"
            icon="flag"
            to="/feature_flags"
            onClick={handleMenuItemClick}
            active={pathname === '/feature_flags'}
        />
        <Menu.Item>
            System Portals
            <Icon name="university" />
            <Menu.Menu>
                <Menu.Item
                    content="List"
                    to="/col/portalSystem"
                    onClick={handleMenuItemClick}
                    active={pathname === '/col/portalSystem'}
                />
                <Menu.Item
                    content="Create"
                    to="/col/portalSystem/create"
                    onClick={handleMenuItemClick}
                    active={pathname === '/col/portalSystem/create'}
                />
            </Menu.Menu>
        </Menu.Item>
    </Fragment>
);

NobleMenu.propTypes = {
    pathname: string.isRequired,
    handleMenuItemClick: func.isRequired,

};

export default NobleMenu;
